import { AbstractClone } from "../../abstract/clone.abstract";
import { Injectable } from "@angular/core";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsTextModel } from "src/app/models/widgets/widgets-text.model";

@Injectable({
  providedIn: 'root'
})
export class CloneTextService extends AbstractClone {

  constructor() {
    super();
  }

  cloneFromJS(origWidget: any,
    destWidget: WidgetsAbstract,
    isDragNDrop: boolean,
    isInsideQuestion: boolean,
    parentId: string | undefined) {
    let orgWidget = origWidget as WidgetsTextModel;
    const newHeader = new WidgetsTextModel();
    newHeader.parentId = parentId;
    newHeader.template = origWidget.template;
    newHeader.label = orgWidget.label;
    newHeader.level = orgWidget.level;

    const container = destWidget as WidgetsContainerAbstract;
    container.children.push(newHeader);
  }
}
